'use client';

import { useMemo } from 'react';
import { useEventing } from '@highereducation/eventing';
import { readMarketingConsent } from '@hen-site/lib/paid-social/consent';
import type { PaidSocialEmitter } from '@hen-site/lib/paid-social/types';

/**
 * Returns the paid-social emit seam, or null when it is unavailable.
 *
 * @returns {PaidSocialEmitter | null} Emitter, or null.
 */
export const usePaidSocialEmitter = (): PaidSocialEmitter | null => {
  const eventing = useEventing();

  return useMemo(() => {
    if (!eventing) {
      return null;
    }

    return {
      trackPageView: (pageUrl) => {
        if (readMarketingConsent() === 'granted') {
          eventing.trackPageView(pageUrl);
        }
      },
      trackConversion: (conversion) => {
        if (readMarketingConsent() === 'granted') {
          eventing.trackConversion(conversion);
        }
      },
    };
  }, [eventing]);
};
